import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { alpha, SxProps, Theme } from '@mui/material/styles';
import { ArcStack, ArcText } from '@src/core/ui';
import { routesConfig } from '@src/core/routes';
import { MoreMenuPanelProps } from '../types';

const moreMenuRowSx: SxProps<Theme> = {
  px: 2,
  py: 1,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: (theme) =>
    theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
    }),
  '&:hover': {
    bgcolor: (theme) => alpha(theme.palette.common.white, 0.08),
  },
};

const MoreMenuPanel: React.FC<MoreMenuPanelProps> = ({ onMarkAllAsRead, onNotificationSettings }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToSettings = () => {
    navigate(routesConfig.settingsNotification);
    onNotificationSettings();
  };

  return (
    <ArcStack
      sx={{
        py: 0.5,
        minWidth: 180,
        bgcolor: 'background.paper',
        borderRadius: 1,
        boxShadow: 4,
        overflow: 'hidden',
      }}>
      <ArcStack sx={moreMenuRowSx} onClick={onMarkAllAsRead}>
        <ArcText.h5 fontSize={12} fontWeight={400}>
          {t('notifications.markAllAsRead')}
        </ArcText.h5>
      </ArcStack>
      <ArcStack sx={moreMenuRowSx} onClick={goToSettings}>
        <ArcText.h5 fontSize={12} fontWeight={400}>
          {t('notifications.settings')}
        </ArcText.h5>
      </ArcStack>
    </ArcStack>
  );
};

export default MoreMenuPanel;
